<template>
    <div class="nobox" v-if="$store.state.show">
        <el-link
        disabled
        class="nodata">
            <img src="/Public/home/images/nodata.png">
        暂无数据</el-link>
    </div>
</template>

<script>
export default {
    name: 'Nodata'
}
</script>

<style scoped>
.nobox {
    min-height: 180px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.list-box .nobox {
    min-height: 320px;
}
.nobox .nodata {
    width: 10%;
    margin: auto;
    display: block;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
}
.nobox .nodata img {
    width: 100%;
}

@media(max-width: 868px) {
    .nobox .nodata {
        width: 20%;
    }
}
</style>